import React from 'react';
import { motion } from 'framer-motion';
import { Mail, BookOpen, Heart } from 'lucide-react';
const steps = [{
  icon: Mail,
  title: 'Receiving',
  description: 'A letter addressed to you, arriving quietly by mail. No notifications, just paper.',
  link: 'Learn more'
}, {
  icon: BookOpen,
  title: 'Reading',
  description: 'A love story written slowly and intimately, just for you. Words chosen with care.',
  link: 'Read a sample'
}, {
  icon: Heart,
  title: 'Remembering',
  description: 'A moment to remember what it feels like to miss someone. To feel presence in absence.',
  link: 'Our philosophy'
}];
export function HowItWorks() {
  return <section id="how-it-works" className="py-24 md:py-32 bg-linen/30" data-id="element-46">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-47">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-48">
          <span className="text-xs uppercase tracking-[0.2em] text-warm-gray block mb-4" data-id="element-49">
            How It Works
          </span>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8" data-id="element-50">
          {steps.map((step, index) => <motion.div key={step.title} className="flex flex-col items-center text-center md:items-start md:text-left group" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: index * 0.2
        }} data-id="element-51">
              <div className="mb-6 p-4 rounded-full bg-white/50 border border-stone/30" data-id="element-52">
                <step.icon className="w-6 h-6 text-warm-gray stroke-[1.5]" data-id="element-53" />
              </div>

              <h3 className="font-serif text-2xl text-charcoal mb-3" data-id="element-54">
                {step.title}
              </h3>
              <p className="font-sans text-warm-gray leading-relaxed mb-4 max-w-xs md:max-w-none" data-id="element-55">
                {step.description}
              </p>

              <a href="#" className="text-sm font-medium text-charcoal border-b border-charcoal/20 pb-0.5 hover:border-charcoal transition-colors" data-id="element-56">
                {step.link}
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}